import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Draggable from 'react-draggable'
import styled from 'styled-components'
import enhanceWithClickOutside from 'react-click-outside'
import _ from 'lodash'

import * as customFieldTypes from 'constants/customFieldTypes'
import TextPopover from './popovers/TextPopover'
import ImagePopover from './popovers/ImagePopover'
import ShopifyPopover from './popovers/ShopifyPopover'
import BulletPointsPopover from './popovers/BulletPointsPopover'
import ShopifyVariantsPopover from './popovers/ShopifyVariantsPopover'
import InstaLayout from './popovers/InstaLayout'
import ProductPopover from './popovers/ProductPopover'
import ActionButtonPopover from './popovers/ActionButtonPopover'
import EmailSettingsPopover from './popovers/EmailSettingsPopover'
import CustomButtonPopover from './popovers/CustomButtonPopover'
import OptionalBlockPopover from './popovers/OptionalBlockPopover'
import VideoScenePopover from './popovers/VideoScenePopover'

const DraggableContainer = styled.div`
  z-index: 1008;
  height: 100%;
  width: 50%;
  position: absolute;
  top: ${props => props.positionTop};
  left: ${props => props.positionLeft};
`

class PopoverContainer extends Component {

  constructor (props) {
    super(props)
    this.state = {
      positionTop: null,
      positionLeft: null,
    }
  }

  handleClickOutside = (e) => {
    const ignoreList = ['colorPicker', 'addProduct', 'js-field-button', 'cropper', 'chrome-picker']
    let ignore = this.props.getIgnorePopoverOusideClick()
    for (const target of e.path) {
      if (ignoreList.indexOf(target.id) > -1) ignore = true
      if (typeof target.className === 'string' && target.className !== undefined && ignoreList.indexOf(target.className) > -1) {
        ignore = true
        e.preventDefault()
      }
    }
    if (!ignore && this.props.isVisible && (e.target.id !== this.props.fieldLabelId)) this.props.closeMyself()
    this.props.setIgnorePopoverOusideClick(false)
  }

  updatePopoverPosition = (positionTop, positionLeft) => {
    // console.log('positionTop positionLeft', positionTop, positionLeft)
    this.setState({ positionTop, positionLeft })
  }

  renderContent () {
    const { app, settings, field, setIgnorePopoverOusideClick } = this.props
    // console.log('this.state.positionTop, left', this.state.positionTop, this.state.positionLeft)
    if (!field) return null
    switch (field.type) {
      case customFieldTypes.PRODUCT: {
        const value = _.get(app.customFields, field.paths[0]) || _.get(settings, field.paths[0])
        return (
          <ProductPopover
            value={value}
            path={field.paths[0]}
            title={field.name}
            closeMyself={this.props.closeMyself}
            popoverSection={this.props.popoverSection}
            field={field}
            app={app}
            updatePosition={this.updatePopoverPosition}
            setIgnorePopoverOusideClick={setIgnorePopoverOusideClick}
          />
        )
      }
      case customFieldTypes.TEXT: {
        const value = _.get(app.customFields, field.paths[0]) || _.get(settings, field.paths[0])
        return (
          <TextPopover
            value={value.toString() || ''}
            path={field.paths[0]}
            title={field.name}
            closeMyself={this.props.closeMyself}
            popoverSection={this.props.popoverSection}
            field={field}
            app={app}
            updatePosition={this.updatePopoverPosition}
          />
        )
      }
      case customFieldTypes.VIDEO:
        let value = _.get(app.customFields, field.paths[0]) || _.get(settings, field.paths[0])
        return (
          <VideoScenePopover
            path={field.paths[0]}
            title={field.name}
            closeMyself={this.props.closeMyself}
            field={field}
            app={app}
            value={value}
            updatePosition={this.updatePopoverPosition}
            popoverSection={this.props.popoverSection}
          />
        )
      case customFieldTypes.IMAGE_LIST:
      case customFieldTypes.BG:
      case customFieldTypes.IMAGE: {
        let currentValue = _.get(app.customFields, field.paths[0])
        if (field.type === customFieldTypes.IMAGE_LIST && _.isNil(currentValue)) {
          currentValue = []
        }
        return (
          <ImagePopover
            assets={_.has(app, 'assets') ? app.assets : {}}
            currentValue={currentValue}
            path={field.paths[0]}
            app={app}
            popoverSection={this.props.popoverSection}
            title={field.name}
            isVideo={field.type === customFieldTypes.VIDEO}
            closeMyself={this.props.closeMyself}
            field={field}
            updatePosition={this.updatePopoverPosition}
          />
        )
      }
      case customFieldTypes.BULLET_POINTS: {
        const values = field.paths.map(path =>
          _.get(app.customFields, path) || _.get(settings, path)
        )
        return (
          <BulletPointsPopover
            values={values}
            paths={field.paths}
            title={field.name}
            closeMyself={this.props.closeMyself}
            field={field}
            app={app}
            updatePosition={this.updatePopoverPosition}
            popoverSection={this.props.popoverSection}
          />
        )
      }
      case customFieldTypes.SHOPIFY_PRODUCT: {
        const productPath = _.clone(field.paths[0])
        productPath.push('productId')
        return (
          <ShopifyPopover
            app={app}
            title={field.name}
            closeMyself={this.props.closeMyself}
            field={field}
            updatePosition={this.updatePopoverPosition}
            currentProductId={_.get(app.customFields, productPath)}
          />
        )
      }
      case customFieldTypes.SHOPIFY_VARIANTS: {
        return (
          <ShopifyVariantsPopover
            app={app}
            title={field.name}
            closeMyself={this.props.closeMyself}
            field={field}
            updatePosition={this.updatePopoverPosition}
            currentProductId={_.get(app.customFields, field.paths[1])}
          />
        )
      }
      case customFieldTypes.INSTA_LAYOUT: {
        const value = _.get(app.customFields, field.paths[0]) || _.get(settings, field.paths[0])
        return (
          <InstaLayout
            value={value}
            path={field.paths[0]}
            appId={app.id}
            title={field.name}
            closeMyself={this.props.closeMyself}
            updatePosition={this.updatePopoverPosition}
          />
        )
      }
      case customFieldTypes.ACTION_BUTTON_W_DESIGN:
      case customFieldTypes.ACTION_BUTTON: {
        const buttonText = _.get(app.customFields, field.paths[0]) || _.get(settings, field.paths[0])
        return (
          <ActionButtonPopover
            buttonText={buttonText.toString() || ''}
            path={field.paths[0]}
            title={field.name}
            closeMyself={this.props.closeMyself}
            field={field}
            app={app}
            updatePosition={this.updatePopoverPosition}
          />
        )
      }
      case customFieldTypes.EMAIL_SETTINGS: {
        const value = _.get(app.customFields, field.paths[0]) || _.get(settings, field.paths[0])
        return (
          <EmailSettingsPopover
            path={field.paths[0]}
            title={field.name}
            closeMyself={this.props.closeMyself}
            field={field}
            app={app}
            value={value}
            updatePosition={this.updatePopoverPosition}
          />
        )
      }
      case customFieldTypes.BUTTONS_CONTAINER:
      case customFieldTypes.CUSTOM_BUTTON_W_URL: {
        let value = settings[field.paths[0][0]].buttonFieldType
        if (app.customFields && app.customFields[field.paths[0][0]] && app.customFields[field.paths[0][0]].buttonFieldType) {
          value = app.customFields[field.paths[0][0]].buttonFieldType
        }
        return (
          <CustomButtonPopover
            path={field.paths[0]}
            title={field.name}
            closeMyself={this.props.closeMyself}
            field={field}
            app={app}
            value={value}
            updatePosition={this.updatePopoverPosition}
          />
        )
      }
      case customFieldTypes.OPTIONAL_BLOCK: {
        const value = _.get(app.customFields, field.paths[0]) || _.get(settings, field.paths[0])
        return (
          <OptionalBlockPopover
            path={field.paths[0]}
            title={field.name}
            closeMyself={this.props.closeMyself}
            field={field}
            app={app}
            value={value}
            updatePosition={this.updatePopoverPosition}
          />
        )
      }
      default:
        return <div />
    }
  }

  onDragStart (e) {
    if (!e.target.classList.contains('editor-popover-top')) {
      return false
    }
  }

  renderContainer () {
    return (
      <Draggable
        defaultPosition={{x: 0, y: 0}}
        position={null}
        handle='.editor-popover-top'
        onStart={this.onDragStart}
      >
        <DraggableContainer positionTop={this.state.positionTop} positionLeft={this.state.positionLeft}>
          {this.renderContent()}
        </DraggableContainer>
      </Draggable>
    )
  }

  render () {
    return (this.props.isVisible) ? this.renderContainer() : null
  }
}

PopoverContainer.propTypes = {
  closeMyself: PropTypes.func.isRequired,
  fieldLabelId: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
  field: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  getIgnorePopoverOusideClick: PropTypes.func.isRequired,
  setIgnorePopoverOusideClick: PropTypes.func.isRequired,
  popoverSection: PropTypes.string
}

export default connect()(enhanceWithClickOutside(PopoverContainer))



// WEBPACK FOOTER //
// ./src/components/editor/PopoverContainer.js